import BodyText from "components/Typography/BodyText"
import { memo } from "react"
import { IoMdAddCircleOutline } from "react-icons/io"
import styled from "styled-components"
import { Colors } from "themes/palette"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 48px 24px 0px 44px;
  height: 50vh;
  width: 90%;
  background-color: ${Colors.white_alt_soft};
  box-shadow: 0px 2px 10px 0px ${Colors.black_alt_soft};
  border-radius: 12px;
`
const Button = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-height: 44px;
  gap: 8px;
  padding: 16px 48px;
  border-radius: 40px;
  background: var(--Gradient-Front, linear-gradient(251deg, #6729ea 29.56%, #002c98 77.48%));
`
const ContainerBox = styled.div`
  display: grid;
  gap: 60px;
  justify-items: center;
  align-items: center;
`

interface Props {
  navigateToCreateStep: () => void
}
const Board = (props: Props) => {
  const { navigateToCreateStep } = props

  return (
    <Container>
      <ContainerBox>
        <BodyText weight="semi-bold" size="medium" color="gray-dark">
          Você ainda não criou nenhum Produto
        </BodyText>
        <Button onClick={navigateToCreateStep}>
          <IoMdAddCircleOutline size={24} color={Colors.white} />
          <BodyText size="medium" weight="semi-bold" color="white">
            Criar novo Produto
          </BodyText>
        </Button>
      </ContainerBox>
    </Container>
  )
}

export default memo(Board)
